

export default function overwriteFn (oldFn: Function, newFn: Function) {
  if (!newFn || !oldFn) return newFn || oldFn;

  return (argv: any) => {
    return oldFn(newFn(argv));
  }
}
